import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidePanelCheckService {

    constructor() { }
    userName = new Subject<any>();
}
